
<template>
  <cdmapprove-component>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            
            <strong>CDM Approve</strong>
          
          </div>

      <!-- Filter  -->
      <b-row>
      <b-col md="12">
        <b-col md="12">  
        <b-row class="form-group">    
                <b-col sm="3" >
                 
              <b-form-group label="DeliveryAgent">
                 <!-- <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select> -->
                  <v-select  v-model="deliveryagentid" :options="agentmaster" placeholder="Select Delivery Agent" @input="selectdeliveryagent(deliveryagentid)"  name="deliveryagentid">
                  </v-select>
               </b-form-group>
                </b-col> 
                <b-col sm="3">
                         
                <b-form-group label="From Date"   >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>

              </b-col>
               <b-col sm="3">
               
                <b-form-group label="To Date"   >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>

              </b-col>
              <b-col sm="2" >     
               <b-button type="submit" size="md" variant="primary" @click="cdmApprovelist()" style="margin-top: 19%;"> Search</b-button>
              </b-col>
            </b-row>
            </b-col>
          </b-col>     
        </b-row>

         <!-- Filter End -->
         <b-col sm="12" class="text-right">

          <b-button v-if="totalRows>0" @click="downloadCSV(Pending)" type="submit" style="margin-right: 10px;margin-bottom:5px;" variant="primary" size="md" >Download </b-button>

         <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRows }}</span></b> </p>
        </b-col> 
        <b-col>

             <b-table responsive show-empty  :busy="isBusy" :items="penApproveitems" :fields="penApprovefields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
            <template slot="receiptno" slot-scope="row">
               <div class="cdm_table">
                {{row.item.receiptno}}
             
            <span  v-if="row.item.receipturl !='undefined' &&row.item.receipturl !=null && row.item.receipturl !=''"  data-toggle="tooltip" @click="reciptImagemodal(row.item)"> 
               <i class="fa fa-file-image-o" aria-hidden="true" data-toggle="tooltip" title="View Image" style="color:  #20a8d8;float:right;cursor:pointer "></i></span>

                   
                 
              </div>

            </template>
             <!-- <template slot="receiptno" slot-scope="row">
               <div class="cdm_table">
                {{row.item.receiptno}}
             
            <span  v-if="row.item.receipturl !='undefined' &&row.item.receipturl !=null && row.item.receipturl !=''"  data-toggle="tooltip"   @click="reciptImagemodal(row.item)"> 
               <i class="fa fa-file-image-o" aria-hidden="true" data-toggle="tooltip" title="View Image" style="color:  #20a8d8;float:right;cursor:pointer "></i></span>

                   
                 
              </div>

            </template> -->
             <template slot="actions" slot-scope="row">
                  <!-- <b-button size="sm" data-toggle="tooltip" @click="feedbackmodal()" title="Give Feedback" class="mr-1">
                  <i class="fa fa-comments-o" aria-hidden="true"></i>
                  </b-button> -->
                  <span style="cursor:pointer;">
                     <span data-toggle="tooltip" title="Give Feedback">
                    <span @click="feedbackmodal()" class="badge badge-info" style="font-size: 12px; color:white;">Feedback</span>
                  </span>
                  </span>

                  <span   style="cursor:pointer;">
                    <span data-toggle="tooltip" title="Approve">
                    <span  @click="approvetoggleInfoModal()" class="badge badge-success" style="font-size: 12px;margin-left: 5px;">Approve</span>
                  </span>
                  <span  data-toggle="tooltip" title="Reject"> 
                    <span @click="rejecttoggleInfoModal()" class="badge badge-danger" style="margin-left: 5px;
    font-size: 12px;">Reject</span>
                  </span>  
                  </span>

              </template>


          </b-table>
        </b-col>
          <b-col md="6" class="my-1" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>

           <!-- Receipt Image Modal -->
         <b-modal v-model="receiptimage" @ok=" receiptimage= false"  title="Receipt Image" hide-footer>
                   <div class="d-block text-center" >
                      <img alt="This image is not available" style="width: 460px;height: 260px;" 
                      v-bind:src="receiptImgpath">  
                    </div>
                     <div>

                      <a :href="receiptImgpath" target="_blank"> <i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Download Recipt" style="color: ##20a8d8;float:right;margin-top:5px;margin-right: 5px;font-size:25px "></i></a> 
                    </div>
    
                </b-modal>

                  <!-- Receipt Image Modal End -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</cdmapprove-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';

export default {
  data: function() {
    return {
      
      
      penApproveitems:[],
      penApprovefields:[
      { key: 'rider_name', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
        { key: 'deposite_amount', label: 'Deposited Amount', sortable: true, sortDirection: 'desc' },
         { key: 'wallet_amount', label: 'Wallet Amount', sortable: true, sortDirection: 'desc' },
           { key: 'pendingcodcollectable', label: 'Pending Amount', sortable: true, sortDirection: 'desc' },
          { key: 'requested_date', label: 'Requested Date', sortable: true, sortDirection: 'desc' },
        { key: 'created_date', label: 'Approved Date', sortable: true, sortDirection: 'desc' },
          { key: 'transaction_type', label: 'Transaction Type', sortable: true, sortDirection: 'desc' },
        //  { key: 'approved_date', label: 'Approved Date', sortable: true, sortDirection: 'desc' },
         { key: 'receiptno', label: 'Receipt No', sortable: true, sortDirection: 'desc' },
          { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc' },
          { key: 'bill_type', label: 'Bill Type', sortable: true, sortDirection: 'desc' },
          { key: 'created_by', label: 'Approved By', sortable: true, sortDirection: 'desc' },
          // { key: 'feedback', label: 'Feedback Msg', sortable: true, sortDirection: 'desc' },
      ],
        selected:'',
        isBusy: false,
        
        Pickup:'',
        email:'',

         selectDateFrom:null,
        selectDateTo:null,
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        agentmaster:[],
        selectDateFrom:new Date(),
        selectDateTo:new Date(),
        deliveryagentid:'',
         receiptimage:false,
         receiptImgpath:'',
        
        
        
    };
  },
   



  computed: {
    sortOptions() {
      }
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.displaydata();
    this.cdmApprovelist();
  },
  methods: {

       // Function for DeliveryAgent dropdown
  
     displaydata: function () {
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentfirstname+ ' '+srData.deliveryagentlastname + '-'+srData.deliveryagentmasterid,
            });
          });
          this.agentmaster = data;   
          // console.log("agentmaster",this.agentmaster);
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    // end
         // Pending For Finance Listing
   cdmApprovelist:function(){
           
       var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // console.log("this.deliveryagentid",typeof this.deliveryagentid);
        var deliveryagentid=(this.deliveryagentid!='')? this.deliveryagentid.key:null;
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      // this.selected_status=status;
     if(formatdateto< fromdate){
           // alert('To date need to be grater than From date');  
           this.$fire({
                  text:"To date need to be greater than From date",
                  type: "warning",
                  timer: 30000
                });     
             return false;
        }
      this.isBusy = true;
         
     
      const obj = {
    
        deliveryagentmasterid:deliveryagentid,
        fromdate:fromdate,
        todate:formatdateto,
        status: 'Approved',
        
         created_by:`${userInfo.sysemailid}`,
         hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
       
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcdmdepositedetails`,obj)
        .then(result => {
          this.isBusy=false;
          if (result.data.returnmsg == "Successful") {

            this.penApproveitems  = result.body.returnvalue;
            // this.imgpath=result.body.returnvalue;
           
            this.totalRows = result.body.returnvalue.length
          
          } else {
             this.penApproveitems=[];
             this.totalRows=0;
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });

   },

    // Receipt Image modal Function

  reciptImagemodal(value) {
        // this.$refs['my-modal'].show();
        this.receiptimage=true;
        this.receiptImgpath=value.receipturl;
        // console.log("urllll", this.receiptImgpath);

      },

      // end

      downloadCSV: function(status) {
  // alert("status");
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
       var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid.key:"";
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      this.selected_status=status;
      
          const csvObj = {
          deliveryagentmasterid:deliveryagentid,
          fromdate:fromdate,
          todate:formatdateto,
          status: 'Approved',
          created_by:`${userInfo.sysemailid}`,
          sysusermasterid:`${userInfo.sysusermasterid}`,
          hub_id:`${userInfo.pickuplocationmasterid}`,
          is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
          };
          console.log("csvobj",csvObj);
          // return false;
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcdmdepositedetailscsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         // alert("Please Check Your Mail For Downlod Link")
          this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
          this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }
        
        });
        
    },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    }, 

    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.deliveryagentid = '';
          this.displaydata();
          this.cdmApprovelist();
        }
         console.log("value_vehicle : ",value_vehicle);
    },
    
  }
};
</script>

<style lang="css">

</style>
